
import { Row, Col, Tag } from 'antd';
import { useState, useEffect, useRef } from 'react';
import { useParams } from "react-router-dom";

import axios from "axios";
import { lazy } from 'react';
import { Suspense } from 'react';

import {
    DndContext,
    DragOverlay,
    closestCorners,
    KeyboardSensor,
    PointerSensor,
    useSensor,
    useSensors
} from "@dnd-kit/core";
import { arrayMove, sortableKeyboardCoordinates } from "@dnd-kit/sortable";

import Container from "./components/Container";
import { Item } from "./components/SortableItem";
import { EyeOutlined, SaveOutlined } from '@ant-design/icons';
import { map } from 'jquery';

const wrapperStyle = {
    display: "flex",
    flexDirection: "row"
};

const defaultAnnouncements = {
    onDragStart(id) {
        console.log(`Picked up draggable item ${id}.`);
    },
    onDragOver(id, overId) {
        if (overId) {
            console.log(
                `Draggable item ${id} was moved over droppable area ${overId}.`
            );
            return;
        }

        console.log(`Draggable item ${id} is no longer over a droppable area.`);
    },
    onDragEnd(id, overId) {
        if (overId) {
            console.log(
                `Draggable item ${id} was dropped over droppable area ${overId}`
            );
            return;
        }

        console.log(`Draggable item ${id} was dropped.`);
    },
    onDragCancel(id) {
        console.log(`Dragging was cancelled. Draggable item ${id} was dropped.`);
    }
};

const ComponentData = () => {

    const [componentData, setComponentData] = useState([
        {
            component_id: 1,
            component_name: "InteractableBanner"
        },
        {
            component_id: 2,
            component_name: "News"
        },
        {
            component_id: 3,
            component_name: "PhotoBlock"
        },
    ]);
    const [pageContainerData, setPageContainerData] = useState([
        {
            container_id: 1,
            data: [
                {
                    component_id: 1,
                    component_name: "InteractableBanner"
                },
            ],
        },
        {
            container_id: 2,
            data: [
                {
                    component_id: 2,
                    component_name: "News"
                },
            ],
        },
        {
            container_id: 3,
            data: [
                {
                    component_id: 3,
                    component_name: "PhotoBlock"
                },
            ],
        },
        {
            container_id: 4,
            data: [
                {
                    component_id: 4,
                    component_name: "Banner"
                },
            ],
        },
        {
            container_id: 5,
            data: [
                {
                    component_id: 5,
                    component_name: "EMILayout"
                },
            ],
        },
        {
            container_id: 6,
            data: [
                {
                    component_id: 6,
                    component_name: "AboutUs"
                },
            ],
        },
        {
            container_id: 7,
            data: [
                {
                    component_id: 7,
                    component_name: "CarouselBanner"
                },
            ],
        },
        {
            container_id: 8,
            data: [
                {
                    component_id: 8,
                    component_name: "HorizentalCard"
                },
            ],
        },
        {
            container_id: 9,
            data: [
                {
                    component_id: 9,
                    component_name: "ProductCard"
                },
            ],
        },
        {
            container_id: 10,
            data: [
                {
                    component_id: 10,
                    component_name: "ProjectResult"
                },
            ],
        },
        {
            container_id: 11,
            data: [
                {
                    component_id: 11,
                    component_name: "HoverReveal"
                },
            ],
        },
        {
            container_id: 13,
            data: [
                {
                    component_id: 13,
                    component_name: "PhotoCard"
                },
            ],
        },
        {
            container_id: 14,
            data: [
                {
                    component_id: 14,
                    component_name: "VideoPlaylist"
                },
            ],
        },
        {
            container_id: 15,
            data: [
                {
                    component_id: 15,
                    component_name: "PagewideCard"
                },
            ],
        },
        {
            container_id: 16,
            data: [
                {
                    component_id: 16,
                    component_name: "PhotoCarousel"
                },
            ],
        },
        {
            container_id: 17,
            data: [
                {
                    component_id: 17,
                    component_name: "Service"
                },
            ],
        },
        {
            container_id: 18,
            data: [
                {
                    component_id: 18,
                    component_name: "ServiceCard"
                },
            ],
        },
        {
            container_id: 19,
            data: [
                {
                    component_id: 19,
                    component_name: "ScrollIcon"
                },
            ],
        },
        {
            container_id: 20,
            data: [
                {
                    component_id: 20,
                    component_name: "ExampleFooter"
                },
            ],
        },
        {
            container_id: 21,
            data: [
                {
                    component_id: 21,
                    component_name: "DegreeBlock"
                },
            ],
        },
        {
            container_id: 22,
            data: [
                {
                    component_id: 22,
                    component_name: "Video"
                },
            ],
        },
        
    ]);

    const [items, setItems] = useState({
        root: ["1", "2", "3"],
        container1: ["4", "5", "6"],
        container2: ["7", "8", "9"],
        container3: []
    });
    const [activeId, setActiveId] = useState();

    const sensors = useSensors(
        useSensor(PointerSensor),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates
        })
    );
    const addContainer = (index, data) => {
        setPageContainerData((prev) => {
            return [
                ...prev,
                {
                    container_id: index,
                    data: [
                        {
                            component_id: data.component_id,
                            component_name: data.component_name
                        },
                    ],

                }
            ]
        })
        // return <Container id="container1" items={items.container1} />

    }

    useEffect(() => {

    }, []);

    const componentRender = (component_name) => {
        const Component = lazy(() => import(`./components/${component_name}`))
        
        return (
            <Col span={24} >

                <Suspense fallback={<div>Loading...</div>}>
                    <Component />
                   
                </Suspense>
            </Col>

        )
        // }
    }
    return (
        <Row gutter={[10, 20]} justify="space-around">
            <Col lg={{ span: 24 }} xs={{ span: 24 }}>
                <Row gutter={[10, 20]} justify="space-around">
                    <DndContext
                        announcements={defaultAnnouncements}
                        sensors={sensors}
                        collisionDetection={closestCorners}
                        onDragStart={handleDragStart}
                        onDragOver={handleDragOver}
                        onDragEnd={handleDragEnd}
                    >
                        {
                            pageContainerData.map((container, containerIndex) => {
                                return (
                                    <>
                                        <Tag color="geekblue">{containerIndex} . {container.data[0].component_name}</Tag>
                                        {/* <Container id={container.container_id} items={container.data} type="page" /> */}
                                        {componentRender(container?.data[0]?.component_name)}
                                    </>
                                )
                            })
                        }
                    </DndContext>
                </Row>
            </Col >
        </Row >
    );

    function findContainer(id) {
        if (id in items) {
            return id;
        }

        return Object.keys(items).find((key) => items[key].includes(id));
    }

    function handleDragStart(event) {
        const { active } = event;
        const { id } = active;

        setActiveId(id);
    }

    function handleDragOver(event) {
        const { active, over, draggingRect } = event;
        const { id } = active;
        const { id: overId } = over;

        // Find the containers
        const activeContainer = findContainer(id);
        const overContainer = findContainer(overId);

        if (
            !activeContainer ||
            !overContainer ||
            activeContainer === overContainer
        ) {
            return;
        }

        setItems((prev) => {
            const activeItems = prev[activeContainer];
            const overItems = prev[overContainer];

            // Find the indexes for the items
            const activeIndex = activeItems.indexOf(id);
            const overIndex = overItems.indexOf(overId);

            let newIndex;
            if (overId in prev) {
                // We're at the root droppable of a container
                newIndex = overItems.length + 1;
            } else {
                const isBelowLastItem =
                    over &&
                    overIndex === overItems.length - 1 &&
                    draggingRect.offsetTop > over.rect.offsetTop + over.rect.height;

                const modifier = isBelowLastItem ? 1 : 0;

                newIndex = overIndex >= 0 ? overIndex + modifier : overItems.length + 1;
            }

            return {
                ...prev,
                [activeContainer]: [
                    ...prev[activeContainer].filter((item) => item !== active.id)
                ],
                [overContainer]: [
                    ...prev[overContainer].slice(0, newIndex),
                    items[activeContainer][activeIndex],
                    ...prev[overContainer].slice(newIndex, prev[overContainer].length)
                ]
            };
        });
    }

    function handleDragEnd(event) {
        const { active, over } = event;
        const { id } = active;
        const { id: overId } = over;

        const activeContainer = findContainer(id);
        const overContainer = findContainer(overId);

        if (
            !activeContainer ||
            !overContainer ||
            activeContainer !== overContainer
        ) {
            return;
        }

        const activeIndex = items[activeContainer].indexOf(active.id);
        const overIndex = items[overContainer].indexOf(overId);

        if (activeIndex !== overIndex) {
            setItems((items) => ({
                ...items,
                [overContainer]: arrayMove(items[overContainer], activeIndex, overIndex)
            }));
        }

        setActiveId(null);
    }
}
export default ComponentData;
